<template>
  <div style="width: 100%;min-height: 200px;height:500px;margin-top: -20px;">
    <div class="input-type-wrap">
      <base-tag label="数据信息"></base-tag>
      <div :class="className">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>模板标题</span>
        </div>
        <div>
          <el-input class="input-form" v-model="templateTitle" placeholder="请输入模板名称" size="mini"
            style="width: 190px;" />
        </div>
      </div>
      <div v-if="isDevicelistShow == true" :class="className">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>CAM制造设备名称</span>
        </div>
        <el-select class="input-select" v-model="order.deviceType" placeholder="请选择设备型号" @change="changeDeviceType"
          size="mini">
          <el-option class="option-item" v-for="item in camDeivceList" :key="item.value" :label="item.label"
            :value="item.value" />
        </el-select>
        <div v-if="order.deviceType=='99'">
          <el-input class="input-form" v-model="order.otherDeviceType" placeholder="请输入设备型号" size="mini" />
        </div>
      </div>
      <!-- 设计软件 -->
      <div v-if="['2010120','2010210','2010220','2010320','2010420','1010120'].includes(subCatalogId)"
        :class="className">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>设计软件</span>
        </div>
        <el-select class="input-select" v-model="designSoftware" placeholder="请选择设计软件" @change="changeSoftware"
          size="mini">
          <el-option class="option-item" v-for="item in designSoftwareList" :key="item.value" :label="item.label"
            :value="item.value" />
        </el-select>
        <div v-if="order.deviceType=='99'">
          <el-input class="input-form" v-model="order.otherDeviceType" placeholder="请输入设备型号" size="mini" />
        </div>
      </div>
    </div>
    <!-- 参数信息 -->
    <div class="order-input-wrap" v-if="!['1010700','1010410','1010510'].includes(subCatalogId)" :key="renovate">
      <base-tag class="param-info" label="参数信息"></base-tag>
      <div class="input-form-wrap el-input-polymerization" v-if="deviceParamDetail.polymerization&&designSoftware=='00'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>聚合度</span>
        </div>
        <input-num :style="{ '--inputColorPolymerization': colorPolymerization}" @edit-num="editNum('polymerization',$event)"
          :num="Number(deviceParamDetail.polymerization)" unit="度" :step="Number(1)" :limit="Number(10)" />
      </div>
      <div class="input-form-wrap el-input-baseHeight" v-if="deviceParamDetail.baseHeight&&designSoftware=='00'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>基台不低于</span>
        </div>
        <input-num :style="{ '--inputColorBaseHeight': colorBaseHeight}" @edit-num="editNum('baseHeight',$event)"
          :num="Number(deviceParamDetail.baseHeight)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-form-wrap el-input-shoulderWidth" v-if="deviceParamDetail.shoulderWidth&&designSoftware=='00'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>肩台宽度</span>
        </div>
        <input-num :style="{ '--inputColorShoulderWidth': colorShoulderWidth}" @edit-num="editNum('shoulderWidth',$event)"
          :num="Number(deviceParamDetail.shoulderWidth)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div class="input-form-wrap el-input-shoulderAngle" v-if="deviceParamDetail.shoulderAngle&&designSoftware=='00'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>肩台角度</span>
        </div>
        <input-num :style="{ '--inputColorShoulderAngle': colorShoulderAngle}" @edit-num="editNum('shoulderAngle',$event)"
          :num="Number(deviceParamDetail.shoulderAngle)" unit="度" :step="Number(1)" :limit="Number(150)" />
      </div>
      <div class="input-form-wrap el-select-input shoulder" v-if="deviceParamDetail.polymerization&&designSoftware=='00'"
        style="margin-left: 3px;margin-top: 0px;">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>肩台与牙龈位置</span>
        </div>
        <el-radio class="givging" v-model="order.gingiva" label="01">龈下</el-radio>
        <el-radio class="givging" v-model="order.gingiva" label="02">齐龈</el-radio>
        <el-radio v-model="order.gingiva" label="03">龈上</el-radio>
      </div>
      <div class="input-form-wrap" style="width: 210px;margin-left: -100px;margin-top: -5px;"
        v-if="['1010210','1010220'].includes(subCatalogId)&&designSoftware=='00'">
        <div class="el-input-supragingival" v-if="deviceParamDetail.supragingival&&designSoftware=='00'">
          <input-num v-if="order.gingiva == '01'||order.gingiva == '03'"
            :style="{ '--inputColorSupragingival': colorSupragingival}" @edit-num="editNum('supragingival',$event)"
            :num="Number(deviceParamDetail.supragingival)" :step="Number(0.5)" :limit="Number(3)" />
        </div>
      </div>
      <div>
        <div class="input-form-wrap plate-param el-input-plateThickness"
          v-if="(deviceParamDetail.plateThickness || plateZero)&&designSoftware=='00'">
          <div class="input-label">
            <span style="color:red">*</span>
            <span>导板厚度</span>
          </div>
          <input-num :style="{ '--inputColorPlateThickness': colorPlateThickness}" @edit-num="editNum('plateThickness',$event)"
            :num="Number(deviceParamDetail.plateThickness)" :step="Number(0.005)" :limit="Number(10)" />
        </div>
        <div class="input-form-wrap params-null-box" v-if="subCatalogId == '1010698' || subCatalogId == '1010699'">
        </div>
        <div class="input-form-wrap plate-param el-input-teethModel"
          v-if="(deviceParamDetail.teethModelDeviation || plateZero)&&designSoftware=='00'">
          <div class="input-label">
            <span style="color:red">*</span>
            <span>牙齿/模型偏移</span>
          </div>
          <input-num :style="{ '--inputColorTeethModel': colorTeethModelDeviation}"
             @edit-num="editNum('teethModelDeviation',$event)":num="Number(deviceParamDetail.teethModelDeviation)"
            :step="Number(0.005)" :limit="Number(10)" />
        </div>
        <div class="input-form-wrap plate-param el-input-recessedRetention"
          v-if="(deviceParamDetail.teethModelDeviation || plateZero)&&designSoftware=='00'">
          <div class="input-label">
            <span style="color:red">*</span>
            <span>倒凹保留量</span>
          </div>
          <input-num :style="{ '--inputColorRecessedRetention': colorRecessedRetentionAmount}"
             @edit-num="editNum('recessedRetentionAmount',$event)" :num="Number(deviceParamDetail.recessedRetentionAmount)"
            :step="Number(0.005)" :limit="Number(10)" />
        </div>
        <div class="input-form-wrap params-null-box" v-if="subCatalogId == '1010698' || subCatalogId == '1010699'">
        </div>
        <div class="input-form-wrap plate-param el-input-theGuideRing"
          v-if="(deviceParamDetail.guideRingCompensatio || plateZero)&&designSoftware=='00'">
          <div class="input-label">
            <span style="color:red">*</span>
            <span>从导环的补偿</span>
          </div>
          <input-num :style="{ '--inputColorTheGuideRing': colorGuideRingCompensatio}"
            @edit-num="editNum('guideRingCompensatio',$event)" :num="Number(deviceParamDetail.guideRingCompensatio)"
            :step="Number(0.005)" :limit="Number(10)" />
        </div>
      </div>
      <!-- </div> -->
      <div v-if="deviceParamDetail.adhesiveGap&&designSoftware=='00'" class="input-form-wrap el-input-adhesivegap">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>黏着剂间隙</span>
        </div>
        <input-num style="background-color: white;" :style="{ '--inputColorAdhesiveGap': colorAdhesiveGap}"
           @edit-num="editNum('adhesiveGap',$event)" :num="Number(deviceParamDetail.adhesiveGap)" :step="Number(0.005)"
          :limit="Number(10)" />
      </div>
      <div v-if="deviceParamDetail.adhesiveExtraGap&&designSoftware=='00'" class="input-form-wrap el-input-adhesiveExtragap">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>额外黏着剂间隙</span>
        </div>
        <input-num :style="{ '--inputColorAdhesiveExtraGap': colorAdhesiveExtraGap}" @edit-num="editNum('adhesiveExtraGap',$event)"
          :num="Number(deviceParamDetail.adhesiveExtraGap)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div v-if="deviceParamDetail.minThick&&designSoftware=='00'" class="input-form-wrap el-input-minthick">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>最小厚度</span>
        </div>
        <input-num :style="{ '--inputColorMinThick': colorMinThick}" @edit-num="editNum('minThick',$event)"
          :num="Number(deviceParamDetail.minThick)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div v-if="deviceParamDetail.wallHeight&&designSoftware=='00'" class="input-form-wrap el-input-wallheight">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>壁高度</span>
        </div>
        <input-num :style="{ '--inputColorWallHeight': colorWallHeight}" @edit-num="editNum('wallHeight',$event)"
          :num="Number(deviceParamDetail.wallHeight)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div v-if="deviceParamDetail.edgeLineDistance&&designSoftware=='00'" class="input-form-wrap el-input-edgeLinedistance">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>到边缘线的距离</span>
        </div>
        <input-num :style="{ '--inputColorEdgeLineDistance': colorEdgeLineDistance}" @edit-num="editNum('edgeLineDistance',$event)"
          :num="Number(deviceParamDetail.edgeLineDistance)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div v-if="deviceParamDetail.smoothDistance&&designSoftware=='00'" class="input-form-wrap el-input-smoothdistance">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>平滑距离</span>
        </div>
        <input-num :style="{ '--inputColorSmoothDistance': colorSmoothDistance}" @edit-num="editNum('smoothDistance',$event)"
          :num="Number(deviceParamDetail.smoothDistance)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div v-if="deviceParamDetail.burRadius&&designSoftware=='00'" class="input-form-wrap el-input-burradius">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>车针半径</span>
        </div>
        <input-num :style="{ '--inputColorBurRadius': colorBurRadius}" @edit-num="editNum('burRadius',$event)"
          :num="Number(deviceParamDetail.burRadius)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div v-if="deviceParamDetail.burGapOffset&&designSoftware=='00'" class="input-form-wrap el-input-burgapoffset">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>车针补偿间距</span>
        </div>
        <input-num :style="{ '--inputColorBurGapOffset': colorBurGapOffset}"  @edit-num="editNum('burGapOffset',$event)"
          :num="Number(deviceParamDetail.burGapOffset)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div v-if="deviceParamDetail.edgeLineOffset&&designSoftware=='00'" class="input-form-wrap el-input-edgelineoffset">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>边缘线补偿</span>
        </div>
        <input-num :style="{ '--inputColorEdgeLineOffset': colorEdgeLineOffset}"  @edit-num="editNum('edgeLineOffset',$event)"
          :num="Number(deviceParamDetail.edgeLineOffset)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div v-if="deviceParamDetail.stretchOffset&&designSoftware=='00'" class="input-form-wrap el-input-stretchoffset">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>延伸补偿</span>
        </div>
        <input-num :style="{ '--inputColorStretchOffset': colorStretchOffset}"  @edit-num="editNum('stretchOffset',$event)"
          :num="Number(deviceParamDetail.stretchOffset)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div v-if="deviceParamDetail.angleOffset&&designSoftware=='00'" class="input-form-wrap el-input-angleoffset">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>补偿角度</span>
        </div>
        <input-num :style="{ '--inputColorAngleOffset': colorAngleOffset}"  @edit-num="editNum('angleOffset',$event)" unit="度"
          :num="Number(deviceParamDetail.angleOffset)" :step="Number(1)" :limit="Number(90)" />
      </div>
      <div v-if="isTonguesideShow&&designSoftware=='00'" class="input-form-wrap" style="margin: 1px 0 0 -43px;height: 48px;">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>舌侧边补偿(宽度)</span>
        </div>
        <div class="input-radio">
          <div class="input-radio-box">
            <el-radio v-model="order.isTongueSide" label="0">无</el-radio>
            <el-radio v-model="order.isTongueSide" label="1">有</el-radio>
          </div>
        </div>
      </div>
      <div class="input-form-wrap el-select-input" v-if="order.isTongueSide=='1'&&designSoftware=='00'">
        <div class="input-label" style="margin: 0px 0 0 9px;">
          <span style="color:red">*</span>
          <span>舌侧边补偿参数</span>
        </div>
        <el-select class="input-form" v-model="order.sideOffset" placeholder="请选择舌侧边补偿参数" size="mini">
          <el-option label="舌侧边" value="0"></el-option>
          <el-option label="360度边" value="1"></el-option>
        </el-select>
      </div>
      <div v-if="deviceParamDetail.tongueSideOffset && order.isTongueSide=='1' && order.sideOffset=='0'&&designSoftware=='00'"
        class="input-form-wrap el-input-tonguesideoffset">
        <div class="input-label" style="margin-top: -5px;">
          <span style="color:red">*</span>
          <span>舌侧边</span>
        </div>
        <input-num :style="{ '--inputColorTongueSideOffset': colorTongueSideOffset}" @edit-num="editNum('tongueSideOffset',$event)"
          :num="Number(deviceParamDetail.tongueSideOffset)" :step="Number(0.005)" :limit="Number(10)"
          style="margin-top: -5px;" />
      </div>
      <div v-if="deviceParamDetail.circleSideOffset && order.isTongueSide=='1' && order.sideOffset=='1'&&designSoftware=='00'"
        class="input-form-wrap el-input-circlesideoffset">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>360度边</span>
        </div>
        <input-num :style="{ '--inputColorCircleSideOffset': colorCircleSideOffset}" @edit-num="editNum('circleSideOffset',$event)"
          :num="Number(deviceParamDetail.circleSideOffset)" :step="Number(0.005)" :limit="Number(10)" />
      </div>
      <div v-if="(deviceParamDetail.occlusalClearance||deviceParamDetail.occlusalClearance == 0)&&
      ['1010120','1010310','1010320','2010120','2010320','2010420'].includes(subCatalogId)&&designSoftware=='00'"
        class="input-form-wrap el-input-occlusalClearance">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>咬合间隙</span>
        </div>
        <input-num :style="{ '--inputColorOcclusalClearance': colorOcclusalClearance}"
        @edit-num="editNum('occlusalClearance',$event)" :num="Number(deviceParamDetail.occlusalClearance)" :step="Number(0.001)"
          :limit="Number(10)" />
      </div>
      <div v-if="(deviceParamDetail.adjacencyGap||deviceParamDetail.adjacencyGap == 0)&&
      ['1010120','1010310','1010320','2010120','2010320','2010420'].includes(subCatalogId)&&designSoftware=='00'"
        class="input-form-wrap el-input-adjacencyGap">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>邻接间隙</span>
        </div>
        <input-num :style="{ '--inputColorAdjacencyGap': colorAdjacencyGap}" @edit-num="editNum('adjacencyGap',$event)"
          :num="Number(deviceParamDetail.adjacencyGap)" :step="Number(0.001)" :limit="Number(10)" />
      </div>
      <div class="input-wrap-exo el-input-inner" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>内冠厚度</span>
        </div>
        <input-num :style="{ '--inputColorInner': colorInnerCrownThickness }" @edit-num="editNum('innerCrownThickness',$event)"
          :num="Number(deviceParamDetail.innerCrownThickness)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-occlusion" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>咬合空间</span>
        </div>
        <input-num :style="{ '--inputColorOcclusion': colorOcclusionSpace }" @edit-num="editNum('occlusionSpace',$event)"
          :num="Number(deviceParamDetail.occlusionSpace)" :step="Number(0.005)" :limit="Number(13)"/>
      </div>
      <div class="input-wrap-exo el-input-adhesive" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>粘接剂厚度</span>
        </div>
        <input-num :style="{ '--inputColorAdhesive': colorAdhesiveThickness }" @edit-num="editNum('adhesiveThickness',$event)"
          :num="Number(deviceParamDetail.adhesiveThickness)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-edge-horizontal" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>边缘水平宽度</span>
        </div>
        <input-num :style="{ '--inputColorEdgeHorizontal': colorEdgeHorizontalWidth }" @edit-num="editNum('edgeHorizontalWidth',$event)"
          :num="Number(deviceParamDetail.edgeHorizontalWidth)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-edge-tilt" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>边缘倾斜宽度</span>
        </div>
        <input-num :style="{ '--inputColorEdgeTilt': colorEdgeTiltWidth }" @edit-num="editNum('edgeTiltWidth',$event)"
          :num="Number(deviceParamDetail.edgeTiltWidth)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-edge-inclination" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>边缘倾斜角度</span>
        </div>
        <input-num :style="{ '--inputColorEdgeInclination': colorEdgeInclinationAngle }" @edit-num="editNum('edgeInclinationAngle',$event)"
          :num="Number(deviceParamDetail.edgeInclinationAngle)" :step="Number(1)" :limit="Number(90)" unit="度"/>
      </div>
      <div class="input-wrap-exo el-input-edge-vertical" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>边缘垂直高度</span>
        </div>
        <input-num :style="{ '--inputColorEdgeVertical': colorEdgeVerticalHeight }" @edit-num="editNum('edgeVerticalHeight',$event)"
          :num="Number(deviceParamDetail.edgeVerticalHeight)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-top" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>顶部粘接剂宽度</span>
        </div>
        <input-num :style="{ '--inputColorTop': colorTopAdhesiveWidth }" @edit-num="editNum('topAdhesiveWidth',$event)"
          :num="Number(deviceParamDetail.topAdhesiveWidth)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-axial" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>轴向额外间隙</span>
        </div>
        <input-num :style="{ '--inputColorAxial': colorAxialExtraClearance }" @edit-num="editNum('axialExtraClearance',$event)"
          :num="Number(deviceParamDetail.axialExtraClearance)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-extra" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>径向额外间隙</span>
        </div>
        <input-num :style="{ '--inputColorExtra': colorRadialExtraClearance }" @edit-num="editNum('radialExtraClearance',$event)"
          :num="Number(deviceParamDetail.radialExtraClearance)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-sectional" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>连接杆横截面积</span>
        </div>
        <input-num :style="{ '--inputColorSectional': colorCrossSectionalAreaConnector }" @edit-num="editNum('crossSectionalAreaConnector',$event)"
          :num="Number(deviceParamDetail.crossSectionalAreaConnector)" :step="Number(0.005)" :limit="Number(13)"
          :unitSize="'01'" unit="mm²"/>
      </div>
      <div class="input-wrap-exo el-input-prohibited" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>禁止填除边缘</span>
        </div>
        <input-num :style="{ '--inputColorProhibited': colorProhibitedFillingMargin }" @edit-num="editNum('prohibitedFillingMargin',$event)"
          :num="Number(deviceParamDetail.prohibitedFillingMargin)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-gingival" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>牙龈厚度</span>
        </div>
        <input-num :style="{ '--inputColorGingival': colorGingivalThickness }" @edit-num="editNum('gingivalThickness',$event)"
          :num="Number(deviceParamDetail.gingivalThickness)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-distance" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>到邻牙距离</span>
        </div>
        <input-num :style="{ '--inputColorDistance': colorDistanceAdjacentTooth }" @edit-num="editNum('distanceAdjacentTooth',$event)"
          :num="Number(deviceParamDetail.distanceAdjacentTooth)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-margin-line" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>边缘线下移</span>
        </div>
        <input-num :style="{ '--inputColorMarginLine': colorMarginLineShift }" @edit-num="editNum('marginLineShift',$event)"
          :num="Number(deviceParamDetail.marginLineShift)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-cement" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>粘接间隙</span>
        </div>
        <input-num :style="{ '--inputColorCement': colorCementGap }" @edit-num="editNum('cementGap',$event)"
          :num="Number(deviceParamDetail.cementGap)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-from" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>从边缘线</span>
        </div>
        <input-num :style="{ '--inputColorFrom': colorFromMarginLine }" @edit-num="editNum('fromMarginLine',$event)"
          :num="Number(deviceParamDetail.fromMarginLine)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
      <div class="input-wrap-exo el-input-margin-cement" v-if="designSoftware == '10'">
        <div class="input-label">
          <span style="color:red">*</span>
          <span>边缘粘接剂宽度</span>
        </div>
        <input-num :style="{ '--inputColorMarginCement': colorMarginCementWidth }" @edit-num="editNum('marginCementWidth',$event)"
          :num="Number(deviceParamDetail.marginCementWidth)" :step="Number(0.005)" :limit="Number(13)" />
      </div>
    </div>
    <y-button style="position: absolute;bottom: 50px;left: 45%;" :text="isEditTemplate=='0'?'生成模版':'修改模版'"
      classStyle="main-btn ml" @btnClick="submitForm"></y-button>
  </div>
</template>

<script>
import BaseTag from '/components/BaseTag'
import YButton from '/components/YButton'
import InputNum from '/components/inputNum'
export default{
  data(){
    return {
      //动态改变文字颜色
      colorContact: '',
      colorPhone: '',
      colorPatient: '',
      colorOrderCount: '',
      colorOrderAmount: '',
      colorAdhesiveGap: '',   //黏着剂间隙
      colorAdhesiveExtraGap: '', //额外黏着剂间隙
      colorMinThick: '',         //最小厚度
      colorWallHeight: '',       //壁高度
      colorEdgeLineDistance: '',   //到边缘线的距离
      colorSmoothDistance: '',   //平滑距离
      colorBurRadius: '',       //车针半径
      colorBurGapOffset: '',     //车针补偿间距
      colorEdgeLineOffset: '',   //边缘线补偿
      colorStretchOffset: '',    //延伸补偿
      colorAngleOffset: '',      //补偿角度
      colorOcclusalClearance:'',//咬合间隙
      colorAdjacencyGap:'',//邻接间隙
      colorTongueSideOffset: '', //舌侧边
      colorCircleSideOffset: '', //360度边
      colorPlateThickness:'', //导板厚度
      colorTeethModelDeviation: '', //牙齿/模型偏移
      colorRecessedRetentionAmount:'', //倒凹保留量
      colorGuideRingCompensatio:'', //从导环的补偿
      colorPolymerization:'', //聚合度
      colorBaseHeight:'', //基台高度
      colorShoulderWidth:'', //肩台宽度
      colorShoulderAngle:'', //肩台角度
      colorSupragingival:'',//龈上参数

      colorInnerCrownThickness:'',
      colorOcclusionSpace:'',
      colorAdhesiveThickness:'',
      colorEdgeHorizontalWidth:'',
      colorEdgeTiltWidth:'',
      colorEdgeInclinationAngle:'',
      colorEdgeVerticalHeight:'',
      colorTopAdhesiveWidth:'',
      colorAxialExtraClearance:'',
      colorRadialExtraClearance:'',
      colorCrossSectionalAreaConnector:'',
      colorProhibitedFillingMargin:'',
      colorGingivalThickness:'',
      colorDistanceAdjacentTooth:'',
      colorMarginLineShift:'',
      colorCementGap:'',
      colorFromMarginLine:'',
      colorMarginCementWidth:'',

      templateTitle:'',
      order:{
        templateTitle:'',//模板标题
        deviceType:'',
        otherDeviceType:'',
        adhesiveGap: 0.03,   //黏着剂间隙
        adhesiveExtraGap: 0.04, //额外黏着剂间隙：0.04mm
        minThick: 0.6,         //最小厚度：0.6mm
        wallHeight: 0.8,       //壁高度：0.8mm
        edgeLineDistance: 1,   //到边缘线的距离：1mm
        smoothDistance: 0.2,   //平滑距离: 0.2mm
        burRadius: 0.5,       //车针半径 : 0.5mm
        burGapOffset: 0.52,     //车针补偿间距: 0.52mm
        edgeLineOffset: 0.15,   //边缘线补偿: 0.15mm
        stretchOffset: 0.1,    //延伸补偿:0.1mm
        angleOffset: 60,      //补偿角度:25-60度
        isTongueSide:'0',       //舌侧边补偿（宽度）0=无,1=有
        sideOffset: '0',    //默认舌侧边
        tongueSideOffset: 1, //舌侧边 1mm
        circleSideOffset: 1, //360度边1mm
        plateThickness: 2, //导板厚度: 2~2.5mm
        teethModelDeviation: 0.05, //牙齿/模型偏移0.05mm
        recessedRetentionAmount: 0, //倒凹保留量 0
        guideRingCompensatio: 0.05, //从导环的补偿 0.05mm
        polymerization: 6, //聚合度 默认6度，-15~15度
        baseHeight:4.5, //基台高度 4.5mm 2~13mm
        shoulderWidth: 1, //肩台宽度 1mm 0.5~1mm
        shoulderAngle: 120, //肩台角度 120度 90~165度
        gingiva: '01', //牙龈位置
        supragingival: 1.00, //龈下参数
        subgingival:'', //精密附件供应商及型号
        occlusalClearance: 0.025,//咬合间隙0.025mm
        adjacencyGap: -0.08,//邻接间隙-0.08mm
      },
      deviceParamDetail:'',//组件的设备参数
      submitParamdata:[],
      backColor:'white',
      addatalists:[],
      addevicelists:[],
      camDeivceList:[],
      withServCataId: 0,
      tempDeviceParam:[],
      designSoftwareList:[
        {
          label:'通用',
          value:'00'
        },
        {
          label:'exocad',
          value:'10'
        },
      ],
      designSoftware:'00',
      renovate: true,
    }
  },
  props:{
    subCatalogId:{
      type:String,
      default:null
    },
    isTonguesideShow:{
      type:Boolean,
      default:false
    },
    isDevicelistShow:{
      type:Boolean,
      default: false
    },
    plateZero:{
      type:Boolean,
      default: false
    },
    form:{
      type:Object,
      default: null
    },
    devicelists:{
      type:Array,
    },
    selectDeviceData:{
      type:[String,Object,Array],
      default: ()=>''
    },
    editDeviceParam:{
      type:[String,Object],
      default: ()=>''
    },
    datalists:{
      type:Array,
      default:null
    },
    isEditTemplate:{
      type:String,
      default:'0'
    },
    camParamList:{
      type:Array,
    }
  },
  computed:{
    className(){
      let arr = ['1010120','2010120','2010220','2010320','2010420'];
      if(arr.includes(this.subCatalogId)){
        return 'input-wrap-exo';
      }
      return 'input-form-wrap';
    }
  },
  methods:{
    changeDeviceType(){
      if(this.designSoftware=='10'){
        return false
      }
      this.deviceParamDetail = []
      for (let i = 0; i < this.datalists.length; i++) {
        if(this.datalists[i].deviceType==this.order.deviceType) {
          this.deviceParamDetail = this.datalists[i]
        }
      }
      if(this.order.deviceType=='99'){
        this.getDeviceInfo()
      }
      this.initDeviceParam(this.deviceParamDetail)
    },
    submitForm() {
      if(this.templateTitle.length>15){
      this.$yxz.msg('模板名称长度上限为15','error')
        return false
      }
      if(this.order.deviceType==''&&['1010210','1010220','1010310','1010320','2010210'].includes(this.servCataId)){
      this.$yxz.msg('请选择cam制造设备名称','error')
        return false
      }
      let formData = new FormData();
      for (var key in this.order) {
        formData.append(key, this.order[key]);
      }
      this.formData = formData;
      this.saveTemplate();
    },
    saveTemplate(){
      var tempDataScan = [];
      var tempDataSheet = [];
      var tempDataMouth = [];
      var tempDataCbct = [];
      var tempDataScanRod = [];
      tempDataScan = JSON.stringify(this.dataScan)
      tempDataSheet = JSON.stringify(this.dataSheet)
      tempDataMouth = JSON.stringify(this.dataMouth)
      tempDataCbct = JSON.stringify(this.dataCbct)
      tempDataScanRod = JSON.stringify(this.dataScanRod)
      var orderData = {
        title:this.templateTitle,
        servCataId: this.subCatalogId,
        demName: this.formData.get('demName'),
        demContact: this.formData.get('demContact'),
        demPhone: this.formData.get('demPhone'),
        demSex: this.formData.get('demSex'),
        demPatient: this.formData.get('demPatient'),
        desLevel: this.formData.get('desLevel'),
        orderCount: this.formData.get('orderCount'),
        orderPrice: this.formData.get('orderPrice'),
        orderRushFlag: this.formData.get('orderRushFlag'),
        orderRushFee: this.formData.get('orderRushFee'),
        orderAmount: this.formData.get('orderAmount'),
        orderRemark: this.formData.get('orderRemark'),
        softType: this.formData.get('softType'),
        otherSoftType: this.formData.get('otherSoftType'),
        dataType: this.formData.get('dataType'),
        otherDataType: this.formData.get('otherDataType'),
        posSingle: this.formData.get('posSingle'),
        posBridge: this.formData.get('posBridge'),
        posHole: this.formData.get('posHole'),
        plateType: this.formData.get('plateType'),
        plateRay: this.formData.get('plateRay'),

        impSystem: this.formData.get('impSystem'),
        impModel: this.formData.get('impModel'),
        impExtra: this.formData.get('impExtra'), // impSystem = 99时

        scanningRod: this.formData.get('scanningRod'), /** 扫描杆 */
        scanningRodSupplier: this.formData.get('scanningRodSupplier'), /** 扫描杆供应商 */
        subgingival: this.formData.get('subgingival'), /** 精密附件及型号 */
        surgicalBoxSupplier: this.formData.get('surgicalBoxSupplier'),
        plantModel: this.formData.get('plantModel'),
        repairMaterial: this.formData.get('repairMaterial'), //修复体材质

        deviceType: this.formData.get('deviceType'),
        otherDeviceType: this.formData.get('otherDeviceType'),
        abutPath: this.formData.get('abutPath'),
        briCraft: this.formData.get('briCraft'),
        collar: this.formData.get('collar'),
        gingiva: this.formData.get('gingiva') == 'undefined'?null:this.formData.get('gingiva'), //牙龈位置
        shoulderPosition:this.formData.get('shoulderPosition') == 'undefined'?null:this.formData.get('shoulderPosition'), //肩台与牙龈位置的（唇侧舌侧近远中）

        adhesiveGap: this.selectDeviceData.adhesiveGap||this.deviceParamDetail.adhesiveGap?this.formData.get('adhesiveGap'):null,   //黏着剂间隙
        adhesiveExtraGap: this.selectDeviceData.adhesiveExtraGap||this.deviceParamDetail.adhesiveExtraGap?this.formData.get('adhesiveExtraGap'):null, //额外黏着剂间隙：0.04mm
        minThick: this.selectDeviceData.minThick||this.deviceParamDetail.minThick?this.formData.get('minThick'):null,         //最小厚度：0.6mm
        wallHeight: this.selectDeviceData.wallHeight||this.deviceParamDetail.wallHeight?this.formData.get('wallHeight'):null,       //壁高度：0.8mm
        edgeLineDistance: this.selectDeviceData.edgeLineDistance||this.deviceParamDetail.edgeLineDistance?this.formData.get('edgeLineDistance'):null,   //到边缘线的距离：1mm
        smoothDistance: this.selectDeviceData.smoothDistance||this.deviceParamDetail.smoothDistance?this.formData.get('smoothDistance'):null,   //平滑距离: 0.2mm
        burRadius: this.selectDeviceData.burRadius||this.deviceParamDetail.burRadius?this.formData.get('burRadius'):null,       //车针半径 : 0.5mm
        burGapOffset: this.selectDeviceData.burGapOffset||this.deviceParamDetail.burGapOffset?this.formData.get('burGapOffset'):null,     //车针补偿间距: 0.52mm
        edgeLineOffset: this.selectDeviceData.edgeLineOffset||this.deviceParamDetail.edgeLineOffset?this.formData.get('edgeLineOffset'):null,   //边缘线补偿: 0.15mm
        stretchOffset: this.selectDeviceData.stretchOffset||this.deviceParamDetail.stretchOffset?this.formData.get('stretchOffset'):null,    //延伸补偿:0.1mm
        angleOffset: this.selectDeviceData.angleOffset||this.deviceParamDetail.angleOffset?this.formData.get('angleOffset'):null,      //补偿角度:25-60度
        isTongueSide: this.formData.get('isTongueSide'),       //舌侧边补偿（宽度）0=无,1=有
        sideOffset: this.formData.get('sideOffset'),  //舌侧边参数 0=舌侧边,1=360度边
        tongueSideOffset: this.selectDeviceData.tongueSideOffset||this.deviceParamDetail.tongueSideOffset?this.formData.get('tongueSideOffset'):null, //舌侧边 1mm
        circleSideOffset: this.selectDeviceData.circleSideOffset||this.deviceParamDetail.circleSideOffset?this.formData.get('circleSideOffset'):null, //360度边1mm

        polymerization: this.selectDeviceData.polymerization||this.deviceParamDetail.polymerization?this.formData.get('polymerization'):null, //聚合度6度
        baseHeight: this.selectDeviceData.baseHeight ||this.deviceParamDetail.baseHeight? this.formData.get('baseHeight'):null, //基台高度 4.5mm
        shoulderWidth: this.selectDeviceData.shoulderWidth ||this.deviceParamDetail.shoulderWidth? this.formData.get('shoulderWidth'):null, //肩台宽度 1mm
        shoulderAngle: this.selectDeviceData.shoulderAngle ||this.deviceParamDetail.shoulderAngle? this.formData.get('shoulderAngle'):null, //肩台角度 120度
        supragingival: this.selectDeviceData.supragingival ||this.deviceParamDetail.supragingival? this.formData.get('supragingival'):null, //龈下参数
        plateThickness: this.selectDeviceData.plateThickness ||this.deviceParamDetail.plateThickness? this.formData.get('plateThickness'):null, //导板厚度
        teethModelDeviation: this.selectDeviceData.teethModelDeviation ||this.deviceParamDetail.teethModelDeviation? this.formData.get('teethModelDeviation'):null, //牙齿/模型偏移
        recessedRetentionAmount: this.selectDeviceData.recessedRetentionAmount ||this.deviceParamDetail.recessedRetentionAmount?this.formData.get('recessedRetentionAmount'):null, //倒凹量
        guideRingCompensatio: this.selectDeviceData.guideRingCompensatio ||this.deviceParamDetail.guideRingCompensatio? this.formData.get('guideRingCompensatio'):null,//导环的补偿
        adjacencyGap: this.selectDeviceData.adjacencyGap||this.deviceParamDetail.adjacencyGap?this.formData.get('adjacencyGap'):null,
        occlusalClearance: this.selectDeviceData.occlusalClearance||this.deviceParamDetail.occlusalClearance?this.formData.get('occlusalClearance'):null,

        innerCrownThickness:this.deviceParamDetail.innerCrownThickness==0||this.deviceParamDetail.innerCrownThickness?this.formData.get('innerCrownThickness'):null,
        occlusionSpace:this.deviceParamDetail.occlusionSpace==0||this.deviceParamDetail.occlusionSpace?this.formData.get('occlusionSpace'):null,
        adhesiveThickness:this.deviceParamDetail.adhesiveThickness==0||this.deviceParamDetail.adhesiveThickness?this.formData.get('adhesiveThickness'):null,
        edgeHorizontalWidth:this.deviceParamDetail.edgeHorizontalWidth==0||this.deviceParamDetail.edgeHorizontalWidth?this.formData.get('edgeHorizontalWidth'):null,
        edgeTiltWidth:this.deviceParamDetail.edgeTiltWidth==0||this.deviceParamDetail.edgeTiltWidth?this.formData.get('edgeTiltWidth'):null,
        edgeInclinationAngle:this.deviceParamDetail.edgeInclinationAngle==0||this.deviceParamDetail.edgeInclinationAngle?this.formData.get('edgeInclinationAngle'):null,
        edgeVerticalHeight:this.deviceParamDetail.edgeVerticalHeight==0||this.deviceParamDetail.edgeVerticalHeight?this.formData.get('edgeVerticalHeight'):null,
        topAdhesiveWidth:this.deviceParamDetail.topAdhesiveWidth==0||this.deviceParamDetail.topAdhesiveWidth?this.formData.get('topAdhesiveWidth'):null,
        axialExtraClearance:this.deviceParamDetail.axialExtraClearance==0||this.deviceParamDetail.axialExtraClearance?this.formData.get('axialExtraClearance'):null,
        radialExtraClearance:this.deviceParamDetail.radialExtraClearance==0||this.deviceParamDetail.radialExtraClearance?this.formData.get('radialExtraClearance'):null,
        crossSectionalAreaConnector:this.deviceParamDetail.crossSectionalAreaConnector==0||this.deviceParamDetail.crossSectionalAreaConnector?this.formData.get('crossSectionalAreaConnector'):null,
        prohibitedFillingMargin:this.deviceParamDetail.prohibitedFillingMargin==0||this.deviceParamDetail.prohibitedFillingMargin?this.formData.get('prohibitedFillingMargin'):null,
        gingivalThickness:this.deviceParamDetail.gingivalThickness==0||this.deviceParamDetail.gingivalThickness?this.formData.get('gingivalThickness'):null,
        distanceAdjacentTooth:this.deviceParamDetail.distanceAdjacentTooth==0||this.deviceParamDetail.distanceAdjacentTooth?this.formData.get('distanceAdjacentTooth'):null,
        marginLineShift:this.deviceParamDetail.marginLineShift==0||this.deviceParamDetail.marginLineShift?this.formData.get('marginLineShift'):null,
        cementGap:this.deviceParamDetail.cementGap==0||this.deviceParamDetail.cementGap?this.formData.get('cementGap'):null,
        fromMarginLine:this.deviceParamDetail.fromMarginLine==0||this.deviceParamDetail.fromMarginLine?this.formData.get('fromMarginLine'):null,
        marginCementWidth:this.deviceParamDetail.marginCementWidth==0||this.deviceParamDetail.marginCementWidth?this.formData.get('marginCementWidth'):null,
        designSoftware: this.designSoftware,
        isEditScanModel: this.formData.get('isEditScanModel'),
        dataScan: '',
        dataSheet: '',
        dataMouth: '',
        dataCbct: '',
        dataScanRod: '',
      }
      orderData.id = this.order.id
      let url = this.isEditTemplate=='0'?'/business/template/add':'/business/template/edit'
      this.$api.post({
        url:url,
        data:orderData
      }).then(res=>{
        if (res.code == 200) {
          this.$yxz.msg(res.msg, 'success')
          this.$emit('changeDialog',false,'0')
          this.initParam()
        } else {
          this.$yxz.msg(res.msg);
        }
      })
    },
    //获取设备列表和对应设备参数api
    getDeviceInfo() {
      this.$api.get({
        url:'/common/deviceParam',
        isToken: false
      }).then(res=>{
        // console.log("设备参数字典！！！！：",res)
        // this.datalists = [];
        // this.devicelists = [];
        this.addatalists = [];
        this.addevicelists = [];
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].servCode==this.catalogId) {
            for (let j = 0; j < res.data[i].children.length; j++) {
             if(res.data[i].children[j].servCode==this.withServCataId){
               if(this.withServCataId=='1010220' || this.withServCataId=='1010210'){
                 this.addatalists.push(res.data[i].children[j])
                 this.selectDeviceDataInfo = this.addatalists[0]
               }else{
                 this.addatalists.push(res.data[i].children[j])
                 var temp = {
                   label: '',
                   value: ''
                 };
                 temp.label = res.data[i].children[j].deviceName;
                 temp.value = res.data[i].children[j].deviceType;
                 this.addevicelists.push(temp)
               }
             }
             if(res.data[i].children[j].servCode==this.subCatalogId) {
               if(this.subCatalogId=='2010210') {
                 this.deviceParamDetail = res.data[i].children[14]
                 this.initDeviceParam(this.deviceParamDetail)
               }else if(this.subCatalogId=='1010220' || this.subCatalogId=='1010210'||this.subCatalogId=='1010310'||this.subCatalogId=='1010320'){
                 this.datalists.push(res.data[i].children[j])
                 this.deviceParamDetail = this.datalists[0]
               }else {
                 this.datalists.push(res.data[i].children[j])
                 var temp = {
                 	label: '',
                 	value: ''
                 };
                 temp.label = res.data[i].children[j].deviceName;
                 temp.value = res.data[i].children[j].deviceType;
                 this.devicelists.push(temp)
               }
             }
            }
          }
        }
        // var temp = {
        // 	label: '其他',
        // 	value: '99'
        // };
        // this.devicelists.push(temp)
        // this.addevicelists.push(temp)
        if(this.subCatalogId == '1010700'){
          this.selectDeviceData = ''
        }
        this.removeDefalutParam()
        if(this.order.deviceType == '99'){
          this.switchif(this.form.deviceType,this.deviceParamDetail,res)
          this.zeroDeviceParam(res,this.selectDeviceData);
        }
        if(this.form.addeviceType == '99'){
          this.switchif(this.form.addeviceType,this.selectDeviceDataInfo,res)
          this.zeroDeviceParam(res,this.selectDeviceDataInfo);
        }
      })
    },
    // switch对用的设备参数
     switchif(type,arr,res){
        if(type == '99'){
          switch(this.subCatalogId){
            case '1010120':
              this.deviceParamDetail = res.data[0].children[3]
            break;
            case '1010698':
              this.deviceParamDetail = res.data[0].children[16]
              this.deviceParamDetail.adjacencyGap = null
              this.deviceParamDetail.occlusalClearance = null
            break;
            case '1010699':
              this.deviceParamDetail = res.data[0].children[16]
              this.deviceParamDetail.adjacencyGap = null
              this.deviceParamDetail.occlusalClearance = null
            break;
            case '2010120':
              this.deviceParamDetail = res.data[1].children[0]
            break;
            case '2010220':
              this.deviceParamDetail = res.data[1].children[0]
              this.isTonguesideShow = true
            break;
            case '2010320':
              this.deviceParamDetail = res.data[1].children[28]
            break;
            case '2010420':
              this.deviceParamDetail = res.data[1].children[32]
            break;
          }
        }
        if(this.form.deviceType == '99'&&this.subCatalogId!='1010210'&&this.subCatalogId!='1010220'){
          this.deviceParamDetail = arr
        }
        if(this.form.addeviceType == '99'&&(this.subCatalogId == '1010210'||this.subCatalogId == '1010220')){
          this.deviceParamDetailInfo = res.data[0].children[3]
        }
      },
      //其他设备类型，设备参数初始0
      zeroDeviceParam(data,arr) {
        let id = this.subCatalogId
        if(id == '1010698'||id == '1010699'){
          this.plateZero = true
          this.match(data.data,'黑格',arr)
        }else if(id == '2010320'||id == '2010420'){
          this.upperZero = true
          this.match(data.data,'柯乐德',arr)
        }else{
          this.upperZero = true
          this.match(data.data,'威兰德',arr)
        }
        this.initDeviceParam(this.selectDeviceData)
      },
      match(data,deviceName,arr){
        data.forEach((val,index)=>{
          val.children.forEach(item=>{
            if(item.servCode == this.subCatalogId&&item.deviceName==deviceName){
              for(var key1 in arr){
                if(key1!='deviceName'&&key1!='deviceType'){
                  arr[key1] = item[key1]
                }
              }
            }
          })
        })
      },
      // 去掉form默认cam参数
      removeDefalutParam(){
        for(var key1 in this.selectDeviceData){
          for(var key2 in this.form){
            if(key1 == key2&&key1!='deviceType'){
              this.form[key1] = this.selectDeviceData[key1]
            }
          }
        }
      },
      //初始化设备参数
        initDeviceParam(deviceData) {
          this.order.adhesiveGap = deviceData.adhesiveGap
          this.order.adhesiveExtraGap = deviceData.adhesiveExtraGap
          this.order.minThick = this.subCatalogId == '2010210'?0.4:(this.subCatalogId=='2010220'?0.6:deviceData.minThick)
          this.order.wallHeight = deviceData.wallHeight
          this.order.edgeLineDistance = deviceData.edgeLineDistance
          this.order.smoothDistance = deviceData.smoothDistance
          this.order.burRadius = deviceData.burRadius
          this.order.burGapOffset = deviceData.burGapOffset
          this.order.edgeLineOffset = deviceData.edgeLineOffset
          this.order.stretchOffset = deviceData.stretchOffset
          this.order.angleOffset = deviceData.angleOffset
          this.order.tongueSideOffset = deviceData.tongueSideOffset
          this.order.circleSideOffset = deviceData.circleSideOffset

          this.order.polymerization = deviceData.polymerization
          this.order.baseHeight = deviceData.baseHeight
          this.order.shoulderWidth = deviceData.shoulderWidth
          this.order.shoulderAngle = deviceData.shoulderAngle
          this.order.supragingival = deviceData.supragingival
          this.order.shoulderPosition = deviceData.shoulderPosition
          this.order.plateThickness = deviceData.plateThickness
          this.order.teethModelDeviation = deviceData.teethModelDeviation
          this.order.recessedRetentionAmount = deviceData.recessedRetentionAmount
          this.order.guideRingCompensatio = deviceData.guideRingCompensatio
          this.order.adjacencyGap = deviceData.adjacencyGap
          this.order.occlusalClearance = deviceData.occlusalClearance
          // exo
          this.order.innerCrownThickness = deviceData.innerCrownThickness
          this.order.occlusionSpace = deviceData.occlusionSpace
          this.order.adhesiveThickness = deviceData.adhesiveThickness
          this.order.edgeHorizontalWidth = deviceData.edgeHorizontalWidth
          this.order.edgeTiltWidth = deviceData.edgeTiltWidth
          this.order.edgeInclinationAngle = deviceData.edgeInclinationAngle
          this.order.edgeVerticalHeight = deviceData.edgeVerticalHeight
          this.order.topAdhesiveWidth = deviceData.topAdhesiveWidth
          this.order.axialExtraClearance = deviceData.axialExtraClearance
          this.order.radialExtraClearance = deviceData.radialExtraClearance
          this.order.crossSectionalAreaConnector = deviceData.crossSectionalAreaConnector
          this.order.prohibitedFillingMargin = deviceData.prohibitedFillingMargin
          this.order.gingivalThickness = deviceData.gingivalThickness
          this.order.distanceAdjacentTooth = deviceData.distanceAdjacentTooth
          this.order.marginLineShift = deviceData.marginLineShift
          this.order.cementGap = deviceData.cementGap
          this.order.fromMarginLine = deviceData.fromMarginLine
          this.order.marginCementWidth = deviceData.marginCementWidth

          this.renovate = !this.renovate;
        },
      // 统一调用然后传递对应字段
      editNum(field,num){
        let chatFirst = field.charAt(0);
        //分别设置字段别名和字段颜色别名
        let fieldName = chatFirst.toLowerCase() + field.slice(1);
        let fieldColorName = chatFirst.toUpperCase() + field.slice(1);

        this.order[fieldName] = Number(num);
        if(this.deviceParamDetail[fieldName] == this.order[fieldName]){
          this[`color${fieldColorName}`] = '#666';
        }else{
          this[`color${fieldColorName}`] = '#2979ff';
        }
      },
      initParam(){
        this.deviceParamDetail = []
        this.order = {}
        this.templateTitle = ''
      },
	  // 移除其他
      removeqita(){
        if(this.camDeivceList!=[]){
          this.devicelists.forEach(val=>{
            if(val.value!='99'){
              this.camDeivceList.push(val)
            }
          })
        }
      },
	  // 判断id赋值
	  templateParameters(){
		let id = this.subCatalogId
		if(this.isEditTemplate=='1'){
		  this.deviceParamDetail = this.editDeviceParam
		  this.order = this.editDeviceParam
		  this.templateTitle = this.editDeviceParam.title
      this.designSoftware = this.editDeviceParam.designSoftware
		}else if(id=='1010210'||id=='1010220'||id=='1010310'||
				 id=='1010320'||id=='2010210'){
			this.$api.get({
			  url:'/common/deviceParam',
			  isToken: false
			}).then(res=>{
				let i = 0
				if(id=='1010210'||id=='1010220'){
					i = id=='1010210'?14:15
					this.deviceParamDetail = res.data[0].children[i]
				}else if(id == '1010310'||id == '1010320'){
					i = id=='1010310'?32:33
					this.deviceParamDetail = res.data[0].children[i]
				}else if(id == '2010210'){
					this.deviceParamDetail = res.data[1].children[14]
				}
			})
    }
  },
  changeSoftware(){
    if(this.designSoftware=='10'){
        for(let i = 0;i<this.camParamList.length;i++){
          if(this.camParamList[i].servCode == '90'){
            this.deviceParamDetail = this.camParamList[i]
          }
        }
      }else{
        if(this.subCatalogId=='2010210'){
          this.deviceParamDetail = this.camParamList[1].children[14]
        }else{
          for (let i = 0; i < this.datalists.length; i++) {
            if (this.datalists[i].deviceType == this.order.deviceType) {
              this.deviceParamDetail = this.datalists[i]
            }
          }
        }
      }
      this.initDeviceParam(this.deviceParamDetail);
      this.$nextTick(()=>{
        this.renovate = !this.renovate;
      })
  }
  },
  created(){
	  this.removeqita()
	  this.templateParameters()
  },
  components: {
    BaseTag,
    YButton,
    InputNum,
  }
}
</script>

<style lang="scss" scoped>
.order-input-wrap {
  width: 100%;
  margin-top: 40px;
  position: relative;
}
.param-info::after,.param-info-hat::after,.param-info-part::after{
	content: '(黑色为默认参数，仅供参考)';
	font-size: 12px;
	position: absolute;
	top: 8px;
	left: 80px;
  }
  .param-info-hat::after{
	top: 18px;
	left: 150px;
  }
  .param-info-part::after{
	top: 18px;
	left: 110px;
  }
  .input-bridge,
  .input-hos-cal,
  .input-factory,
  .input-not-rush,
  .input-form-wrap,
  .input-wrap-exo,
  .input-hos-cal-one,
  .input-fac-cal-one,
  .input-fac-cal-two,
  .input-fac-cal-null,
  .input-check-cal-two,
  .input-factory-count,
  .input-form-wrap-row,
  .input-form-wrap-plate,
  .input-form-wrap-price,
  .input-form-wrap-craft,
  .input-form-precise{
    float: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 13px;
  }

  .input-form-wrap,.input-wrap-exo {
    // width: 50%;
    // width: 33.33%;
    padding: 3px 10px;
    font-size: 13px;
    /deep/ .input-label {
      text-align:left !important;
      width: 120px;
    }
  }
  .input-wrap-exo{
    width: 33.33%;
  }
  .input-form-wrap{
    width: 50%;
  }

  @import "../../../assets/style/mixin";
  .el-input-contact {
    .el-input /deep/ .el-input__inner {
        color: var(--inputColorContact);
    }
  }
  .el-input-phone {
    .el-input /deep/ .el-input__inner {
        color: var(--inputColorPhone);
    }
  }
  .el-input-patient {
    .el-input /deep/ .el-input__inner {
        color: var(--inputColorPatient);
    }
  }
  .el-input-ordercount {
    .el-input /deep/ .el-input__inner {
        color: var(--inputColorOrderCount);
    }
  }
  .el-input-orderamount {
    .el-input /deep/ .el-input__inner {
        color: var(--inputColorOrderAmount);
    }
  }
  .el-input-adhesivegap {
    /deep/ .select-input {
      color: var(--inputColorAdhesiveGap) !important;
    }
  }
  .el-input-adhesiveExtragap {
    /deep/ .select-input {
      color: var(--inputColorAdhesiveExtraGap) !important;
    }
  }
  .el-input-minthick {
    /deep/ .select-input {
      color: var(--inputColorMinThick) !important;
    }
  }
  .el-input-wallheight {
    /deep/ .select-input {
      color: var(--inputColorWallHeight) !important;
    }
  }
  .el-input-edgeLinedistance {
    /deep/ .select-input {
      color: var(--inputColorEdgeLineDistance) !important;
    }
  }
  .el-input-smoothdistance {
    /deep/ .select-input {
      color: var(--inputColorSmoothDistance) !important;
    }
  }
  .el-input-burradius {
    /deep/ .select-input {
      color: var(--inputColorBurRadius) !important;
    }
  }
  .el-input-burgapoffset {
    /deep/ .select-input {
      color: var(--inputColorBurGapOffset) !important;
    }
  }
  .el-input-edgelineoffset {
    /deep/ .select-input {
      color: var(--inputColorEdgeLineOffset) !important;
    }
  }
  .el-input-stretchoffset {
    /deep/ .select-input {
      color: var(--inputColorStretchOffset) !important;
    }
  }
  .el-input-angleoffset {
    /deep/ .select-input {
      color: var(--inputColorAngleOffset) !important;
    }
  }
  .el-input-occlusalClearance {
    /deep/ .select-input {
      color: var(--inputColorOcclusalClearance) !important;
    }
  }
  .el-input-adjacencyGap {
    /deep/ .select-input {
      color: var(--inputColorAdjacencyGap) !important;
    }
  }
  .el-input-tonguesideoffset {
    /deep/ .select-input {
      color: var(--inputColorTongueSideOffset) !important;
    }
  }
  .el-input-circlesideoffset {
    /deep/ .select-input {
      color: var(--inputColorCircleSideOffset) !important;
    }
  }
  .el-input-plateThickness{
    /deep/ .select-input {
      color: var(--inputColorPlateThickness) !important;
    }
  }
  .el-input-recessedRetention{
    /deep/ .select-input {
      color: var(--inputColorRecessedRetention) !important;
    }
  }
  .el-input-theGuideRing{
    /deep/ .select-input {
      color: var(--inputColorTheGuideRing) !important;
    }
  }
  .el-input-teethModel{
    /deep/ .select-input {
      color: var(--inputColorTeethModel) !important;
    }
  }
  .el-input-polymerization{
    /deep/ .select-input {
      color: var(--inputColorPolymerization) !important;
    }
  }
  .el-input-baseHeight{
    /deep/ .select-input {
      color: var(--inputColorBaseHeight) !important;
    }
  }
  .el-input-shoulderWidth{
    /deep/ .select-input {
      color: var(--inputColorShoulderWidth) !important;
    }
  }
  .el-input-shoulderAngle{
    /deep/ .select-input {
      color: var(--inputColorShoulderAngle) !important;
    }
  }
  .el-input-supragingival{
    /deep/ .select-input {
      color: var(--inputColorSupragingival) !important;
    }
  }
// exo
  .el-input-inner{
    /deep/ .select-input {
      color: var(--inputColorInner) !important;
    }
  }
  .el-input-occlusion{
    /deep/ .select-input {
      color: var(--inputColorOcclusion) !important;
    }
  }
  .el-input-adhesive{
    /deep/ .select-input {
      color: var(--inputColorAdhesive) !important;
    }
  }
  .el-input-edge-horizontal{
    /deep/ .select-input {
      color: var(--inputColorEdgeHorizontal) !important;
    }
  }
  .el-input-edge-tilt{
    /deep/ .select-input {
      color: var(--inputColorEdgeTilt) !important;
    }
  }
  .el-input-edge-inclination{
    /deep/ .select-input {
      color: var(--inputColorEdgeInclination) !important;
    }
  }
  .el-input-edge-vertical{
    /deep/ .select-input {
      color: var(--inputColorEdgeVertical) !important;
    }
  }
  .el-input-top{
    /deep/ .select-input {
      color: var(--inputColorTop) !important;
    }
  }
  .el-input-axial{
    /deep/ .select-input {
      color: var(--inputColorAxial) !important;
    }
  }
  .el-input-extra{
    /deep/ .select-input {
      color: var(--inputColorExtra) !important;
    }
  }
  .el-input-sectional{
    /deep/ .select-input {
      color: var(--inputColorSectional) !important;
    }
  }
  .el-input-prohibited{
    /deep/ .select-input {
      color: var(--inputColorProhibited) !important;
    }
  }
  .el-input-gingival{
    /deep/ .select-input {
      color: var(--inputColorGingival) !important;
    }
  }
  .el-input-distance{
    /deep/ .select-input {
      color: var(--inputColorDistance) !important;
    }
  }
  .el-input-margin-line{
    /deep/ .select-input {
      color: var(--inputColorMarginLine) !important;
    }
  }
  .el-input-cement{
    /deep/ .select-input {
      color: var(--inputColorCement) !important;
    }
  }
  .el-input-from{
    /deep/ .select-input {
      color: var(--inputColorFrom) !important;
    }
  }
  .el-input-margin-cement{
    /deep/ .select-input {
      color: var(--inputColorMarginCement) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// paramTemplate.vue?5feee240